const { h, render, Component } = require('preact');
const GuestHelp = require('../guest/guest_help');
const Web2018Helper = require('../../../helper');


class ArticleView extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
  }

  handleClick() {
    this.props.handleNeedHelpFromSearchResults(this.props.article);
  }

  showGuestHelpOptions() {
    return Web2018Helper.showGuestHelpOptions(this.props.article) 
      && this.props.showGuestHelp // The user has not already checked the FAQ (in which case show the contact channel link will be shown).
  }

  render() {
    let article = this.props.article;
    let articleTitle = <p class="article-title">{article.title}</p>;

    return (
      <li>
        <div id={article.contentId + "-collapsed"} class="article-collapsed">
          <div onClick={this.props.showArticle} class="article-header-collapsed"
            data-bhw={"web2018_" + article.contentId + "_category_" + article.dropdownCategory + "_subcategory_" + article.dropdownSubcategory + "_article_header_collapsed"}>
            <span class="icon-arrow-right-large article-header-arrow"></span>
            {articleTitle}
          </div>
        </div>

        <div id={article.contentId + "-expanded"} class="article-expanded">
          <div onClick={this.props.hideArticle} class="article-header-expanded"
            data-bhw={"web2018_" + article.contentId + "_category_" + article.dropdownCategory + "_subcategory_" + article.dropdownSubcategory + "_article_header_expanded"}>
            <span class="icon-arrow-down-large article-header-arrow"></span>
            {articleTitle}
          </div>

          <div class="article-content">
            <div dangerouslySetInnerHTML={{ __html: article.answer }} />
            {
              this.showGuestHelpOptions() ?
                (<GuestHelp article={article} onClickHelp={this.props.onGuestHelp} />) :
                (
                  <p class="contact-us-section">
                    {I18n.translate("js.modules.web_2018.still_need_help")}&nbsp;
              <span class="contact-us-link" onclick={this.handleClick} data-bhw={"web2018_" + article.contentId + "_category_" + article.dropdownCategory + "_subcategory_" + article.dropdownSubcategory + "_article_contact_us_link"}>
                      {I18n.translate("js.modules.support.contactus")}
                    </span>
                  </p>
                )
            }
            <hr />
          </div>
        </div>
      </li>
    );
  }
}
module.exports = ArticleView
